/**
 * Meta descriptions, clamped to what a search result shows.
 *
 * Google cuts snippets at roughly 155-160 characters and Ahrefs flags any meta
 * description over 160. An article without a meta_description falls back to its
 * excerpt, and excerpts often run past 300 characters, so the 2026-10-06 Ahrefs
 * site audit listed many articles as "Meta description too long".
 *
 * server.js has a copy of this function (clampDescription) for the tags it renders.
 * Keep the two identical, or the server's description and the one react-helmet
 * writes after load disagree again.
 */
export const DESCRIPTION_MAX = 155;

export function clampDescription(text: string | null | undefined, max = DESCRIPTION_MAX): string {
  const t = String(text ?? '').replace(/\s+/g, ' ').trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max);
  // A word that ends exactly at the limit is whole; otherwise back up to the last
  // space, unless that would throw away more than 40% of the text.
  const space = t[max] === ' ' ? max : cut.lastIndexOf(' ');
  return (space > max * 0.6 ? cut.slice(0, space) : cut).replace(/[\s,;:.\-–—]+$/, '') + '…';
}
